import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { H3, TextSmall } from '@/components/Typography/Typography';

const ContractExpiredText: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <H3 weight="bold" className="!leading-none mb-2">
        {t('There’s still a chance!')}
      </H3>
      <TextSmall className="!leading-1.2 !text-white/60 max-w-[18rem] text-center">
        {t(
          'You can extend the time to complete the contract. The offer is limited, decide now!',
        )}
      </TextSmall>
    </>
  );
};

export { ContractExpiredText };
